import Vue from "vue";

export const formatCountryCode = (countryCode: string) => {
    const countries = (window as any)._countries;
    return countries[countryCode] || '';
};

Vue.filter('formatCountryCode', formatCountryCode);
